export function timeAgo(dateStr) {
  const now = new Date();
  const date = new Date(dateStr);
  const diffMs = now - date;
  const diffMin = Math.floor(diffMs / 60000);

  if (diffMin < 1) return 'ora';
  if (diffMin < 60) return `${diffMin} min fa`;

  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH} ore fa`;

  const diffD = Math.floor(diffH / 24);
  if (diffD === 1) return 'ieri';
  if (diffD < 30) return `${diffD} giorni fa`;

  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}
